module.exports = __webpack_public_path__ + "img/modal-create-labels-fl.1f228d8c.svg";